import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchHints } from '../actions/hints';
import ReferenceSearch from './referenceSearch';
import Footer from './footer';
import ReferenceList from './referenceList';

class Sidebar extends Component {
  state = { term: '' }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchHints());
  }

  handleFilterValidator = (text) => {
    this.setState({
      term: text,
    });
  }

  getFilteredList = () => {
    const { hints } = this.props;
    const codes = { ...hints };
    let filtered = codes;
    const { term } = this.state;
    if (term) {
      filtered = _.pickBy(codes, (code, key) => {
        const validatorName = code.name.toLowerCase();
        return (key.toLowerCase().startsWith(term.toLowerCase()) || validatorName.startsWith(term.toLowerCase()));
      });
    }
    const listItems = filtered;
    return { totalCount: Object.keys(filtered).length, data: listItems };
  };

  render() {
    const { totalCount, data: validators } = this.getFilteredList();
    const { selectedCode, onSelectedCode } = this.props;
    const { term } = this.state;
    return (
      <nav className="sidebar">
        <ReferenceSearch onFilter={this.handleFilterValidator} />
        {(term.length > 0 && totalCount === 0) && (
          <div className="list">
            <p className="list__notfound">
              Reference code with prefix
              {' '}
              <b>{term}</b>
              {' '}
              not found
            </p>
          </div>)
        }
        <ReferenceList
          validators={validators}
          totalCount={totalCount}
          selectedCode={selectedCode}
          onSelectedCode={onSelectedCode}
        />
        <Footer />
      </nav>
    );
  }
}
Sidebar.defaultProps = {
  selectedCode: '',
};

Sidebar.propTypes = {
  hints: PropTypes.shape({
    name: PropTypes.string,
    start_code: PropTypes.string,
  }).isRequired,
  onSelectedCode: PropTypes.func.isRequired,
  selectedCode: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  hints: state.hints,
});
export default connect(mapStateToProps)(Sidebar);
